import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'promotional_events-pdp_promo_banner-click';

/**
 * Promo banner "learn more" on click in PDP
 */
export function trackPromotionalEventsPdpPromoBannerClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
